<span>Recent Lookups</span>
<ul>
  <li *ngFor="let lookup of lookups" (click)="click(lookup)">{{lookup}}</li>
</ul>
